import type { DashboardViewModel } from '~/types';
import { TRANSACTIONS_ALL_TABLE_IDENTIFIER } from '~/types/views';

export const viewsListData: DashboardViewModel[] = [
  {
    Id: 'lw-default',
    TableIdentifier: TRANSACTIONS_ALL_TABLE_IDENTIFIER,
    IsDefault: true,
    Scope: 'global',
    Position: 0,
    ViewContent: {
      name: '',
      gridState: {},
      externalFilters: {},
      shortcut: 'thisMonth'
    }
  },
  {
    Id: 'platform-shared-view',
    TableIdentifier: TRANSACTIONS_ALL_TABLE_IDENTIFIER,
    IsDefault: false,
    Scope: 'platform',
    Position: 1,
    ViewContent: {
      name: 'Platform shared view',
      gridState: {
        columns: [
          { dataField: 'id', visible: true },
          { dataField: 'date', visible: true },
          { dataField: 'status', visible: true }
        ]
      },
      externalFilters: {},
      shortcut: ''
    }
  },
  {
    Id: 'my-view',
    UserId: 1,
    PartnerName: 'test001atosv2',
    TableIdentifier: TRANSACTIONS_ALL_TABLE_IDENTIFIER,
    IsDefault: false,
    Scope: 'own',
    Position: 2,
    ViewContent: {
      name: 'My high amounts',
      gridState: {
        columns: [
          { dataField: 'id', visible: true },
          { dataField: 'date', visible: true },
          { dataField: 'amount', visible: true, sortOrder: 'desc', sortIndex: 0 },
          { dataField: 'status', visible: true },
          { dataField: 'settlementDate', visible: false },
          { dataField: 'comment', visible: false }
        ]
      },
      externalFilters: {
        amount: { fieldName: 'amount', operator: '>', value: '1000' }
      },
      shortcut: ''
    }
  },
  {
    Id: 'refunded-transactions',
    UserId: 1,
    PartnerName: 'test001atosv2',
    TableIdentifier: TRANSACTIONS_ALL_TABLE_IDENTIFIER,
    IsDefault: false,
    Scope: 'own',
    Position: 3,
    ViewContent: {
      name: 'Refunded transactions',
      gridState: {
        columns: [
          { dataField: 'id', visible: true },
          { dataField: 'date', visible: true, sortOrder: 'desc', sortIndex: 0 },
          { dataField: 'category', visible: true },
          { dataField: 'comment', visible: true },
          { dataField: 'settlementDate', visible: false },
          { dataField: 'PaymentMeanDataProvider', visible: false }
        ]
      },
      externalFilters: {
        comment: { fieldName: 'comment', operator: 'contains', value: 'refund' }
      },
      shortcut: 'thisYear'
    }
  },
  {
    Id: 'failed-payments',
    UserId: 1,
    PartnerName: 'test001atosv2',
    TableIdentifier: TRANSACTIONS_ALL_TABLE_IDENTIFIER,
    IsDefault: false,
    Scope: 'own',
    Position: 4,
    ViewContent: {
      name: 'Failed payments',
      gridState: {
        columns: [
          { dataField: 'id', visible: true },
          { dataField: 'date', visible: true, sortOrder: 'asc', sortIndex: 0 },
          { dataField: 'status', visible: true },
          { dataField: 'pspError', visible: true },
          { dataField: 'bankTransferType', visible: false },
          { dataField: 'PaymentMeanDataProvider', visible: false }
        ]
      },
      externalFilters: {
        status: { fieldName: 'status', operator: '=', value: '7' }
      },
      shortcut: 'lastSevenDays'
    }
  }
];
